import React, { Component } from "react"
import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link } from "react-router-dom"
import {
  Segment,
  Form,
  Label,
  Container,
  TextArea,
  Grid,
  Dropdown,
  Input,
  Button,
  Icon
} from "semantic-ui-react"
import "./ParametreMonEntreprise.css"
import _ from "lodash"

const options = [
  { key: 1, text: "value_dropdown_5mois", value: 1 },
  { key: 2, text: "value_dropdown_6mois", value: 2 }
]
const optionsAnnée = [
  { key: 1, text: "value_dropdown_1998", value: 1 },
  { key: 2, text: "value_dropdown_2002", value: 2 },
  { key: 3, text: "value_dropdown_2006", value: 3 },
  { key: 4, text: "value_dropdown_2010", value: 4 },
  { key: 5, text: "value_dropdown_2014", value: 5 },
  { key: 6, text: "value_dropdown_2018", value: 6 }
]

class ParametreMonEntreprise extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentWillMount() {
    let { t } = this.props
    var optionsCopy = _.clone(options)
    optionsCopy = _.map(optionsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })
    var optionsAnnéeCopy = _.clone(optionsAnnée)
    optionsAnnéeCopy = _.map(optionsAnnéeCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      options: optionsCopy,
      optionsAnnée: optionsAnnéeCopy
    })
  }

  render() {
    let { t } = this.props

    return (
      <Container fluid id="containerParametre">

        <h3 id="containerParametreDescription">
          {t("title_description")}
        </h3>

        <Segment>
          <Form>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={8} tablet={8} mobile={16}>
                  <Form.Group>
                    <Form.Field>
                      <Label className="labelMonEntreprise">
                        {t("input_duré_devis")}
                      </Label>
                      <Dropdown
                        id="dropdownFormActivity"
                        search
                        selection
                        wrapSelection={false}
                        options={this.state.options || []}
                        placeholder={t("placeholder_mois")}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group>
                    <Form.Field>
                      <Label className="labelMonEntreprise">
                        {t("input_taille_entreprise")}
                      </Label>
                      <Input labelPosition="right" type="text" placeholder="">
                        <Form.Input
                          id="inputTaille"
                          placeholder={t("placeholder_entreprise")}
                        />
                        <Label id="inputTailleLabel">{t("placeholder_label_employe")}</Label>
                      </Input>
                    </Form.Field>
                  </Form.Group>
                  <Form.Group>
                    <Form.Field>
                      <Label className="labelMonEntreprise">
                        {t("input_year_create_enterprise")}
                      </Label>
                      <Dropdown
                        className="dropdownForm"
                        search
                        selection
                        placeholder={t("placeholder_anneé")}
                        wrapSelection={false}
                        options={this.state.optionsAnnée || []}
                      />
                    </Form.Field>
                  </Form.Group>
                </Grid.Column>
                <Grid.Column width={8} />
              </Grid.Row>
            </Grid>
          </Form>
        </Segment>
      </Container>
    )
  }
}

export default translate("ProParamCorp")(ParametreMonEntreprise)



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/MonEntreprise/ParametreMonEntreprise.jsx